export default __webpack_public_path__ + "static/media/files.43685e15.svg";